export const providerOptions = [
  { value: 'twilio', label: 'Twilio' },
  { value: 'telnyx', label: 'Telnyx' },
];
